<template>
  <div class="sf-express-info">
    <div class="header">
      <img src="../../assets/imgs/sf-express.png" width="24" height="24" alt="sf-express">
      <span class="service-name">顺丰上门取资料</span>
      <span class="tips" v-if="isSFPickuped(order)">顺丰会在取件前通过短信发送快递员联系方式，若快递员未及时上门，请根据短信提供的信息联系快递员。</span>
    </div>
    <div class="content">
      <ul>
        <li class="sf-info" v-if="!SFExpressInfoList || (SFExpressInfoList && SFExpressInfoList.length === 0)">暂无取件动态，请耐心等待！</li>
        <li class="sf-info" :class="{'active': index === 0}" v-for="(message, index) in SFExpressInfoList"
          :key="index" v-text="message.context + '（' + message.time + '）'"></li>
      </ul>

      <div class="more-info" @click="showMoreSFInfos(order.pickup_route)"
          v-if="order.pickup_route && order.pickup_route.length > SFExpressShowMoreLength">
        <span class="show-more">查看更多
        <img :class="{'rotate': order.pickup_route && (order.pickup_route.length === SFExpressInfoList.length)}"
            src="../../assets/imgs/arrow-down.png" alt="more"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'sfExpressInfo',
  props: {
    order: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      SFExpressInfoList: this.SFExpressInfos,
      SFExpressShowMoreLength: 3,
    };
  },
  methods: {

    /**
    * 是否显示顺丰是否已取件
    * @param {Object} order 订单信息
    * @return {Boolean} 是否展示
    */
    isSFPickuped(order) {
      if (!order) return false;

      return order.order_pickup && order.order_pickup.length > 0 && order.order_pickup[0].status < 2;
    },

    /**
     * 显示更多的顺丰信息
     * @param {Array} pickup_route 顺丰路由信息
     */
    showMoreSFInfos(pickup_route) {
      if (!pickup_route) return false;
      if (this.SFExpressInfoList.length === pickup_route.length) {
        this.SFExpressInfoList = this.sliceSFPickupRoute(pickup_route, this.SFExpressShowMoreLength);
      } else {
        this.SFExpressInfoList = pickup_route;
      }
    },

    /**
     * 截取顺丰路由信息数组
     * @param {Array} pickup_route 顺丰路由信息
     * @param {Number} length 截取长度
     * @return {Array} 截取后的结果
     */
    sliceSFPickupRoute(pickup_route, length) {
      if (!pickup_route) return [];
      if (pickup_route && pickup_route.length >= length) {
        return pickup_route.slice(0, length);
      }
      return pickup_route;
    },
  },
  created() {
    this.SFExpressInfoList = this.sliceSFPickupRoute(this.order.pickup_route, this.SFExpressShowMoreLength);
  },
};
</script>

<style lang="less" scoped>
.sf-express-info {
  margin: 15px 40px 0 40px;
  padding-bottom: 15px;
  border-bottom: 1px solid #f0f0f0;
  .header {
    padding: 15px 20px;
    border-bottom: 1px solid #f0f0f0;
    background-color: #fbfbfb;
    display: flex;
    align-items: center;
    .service-name {
      margin-left: 5px;
      font-size: 16px;
      color: #333;
    }
    .tips {
      margin-left: 15px;
      font-size: 12px;
      color: #777;
    }
  }
  .content {
    padding: 15px 50px 0 50px;
    overflow: hidden;
    background-color: #fbfbfb;
    ul {
      list-style: none;
      position: relative;
      &:before {
        content: '';
        position: absolute;
        z-index: 1;
        left: 3px;
        top: 3px;
        width: 1px;
        height: 100%;
        background-color: #cfcfcf;
      }
      &:after {
        content: '';
        position: absolute;
        z-index: 2;
        left: 3px;
        bottom: -3px;
        width: 1px;
        height: 6px;
        background-color: #fbfbfb;
      }
      .sf-info {
        color: #aaa;
        font-size: 12px;
        line-height: 12px;
        margin-bottom: 13px;
        padding-left: 15px;
        position: relative;
        &.active {
          font-size: 14px;
          line-height: 14px;
          color: #333;
          &:before {
            background-color: #333;
          }
        }
        &:before {
          content: '';
          position: absolute;
          z-index: 3;
          left: 0;
          top: 4px;
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background-color: #cfcfcf;
        }
      }
    }
    .more-info {
      .show-more {
        display: inline-flex;
        align-items: center;
        font-size: 12px;
        line-height: 12px;
        cursor: pointer;
        color: #5e9be1;
        margin-bottom: 15px;
        img {
          transition: all .5s;
          display: inline-block;
          vertical-align: middle;
          &.rotate {
            transform: rotate(180deg);
          }
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/order-detail/sf-express-info.vue